export let InputTypeEnum = /*#__PURE__*/function (InputTypeEnum) {
  InputTypeEnum["NORMAL"] = "normal";
  InputTypeEnum["BIG_INPUT"] = "big-input";
  InputTypeEnum["FLOAT"] = "float";
  InputTypeEnum["BOTTOM"] = "bottom";
  return InputTypeEnum;
}({});